// Which entry point this page is (design §15): app.{base} (sign-up, workspace finder, sign-in relay),
// admin.{base} (platform console), {slug}.{base} (a tenant's app and signer links). The base comes from config.json.
import { config } from "./auth";

export type Mode = { kind: "app" } | { kind: "admin" } | { kind: "tenant"; slug: string } | { kind: "other" };

const RESERVED = new Set("admin app api www auth login sandbox mail bounce status help support docs static cdn assets ebookme bookme billing pricing signup prod dev staging".split(" "));

export function mode(): Mode {
  const base = config()?.base?.toLowerCase();
  const h = location.hostname.toLowerCase();
  if (!base || !h.endsWith(`.${base}`)) return { kind: "other" };
  const sub = h.slice(0, -(base.length + 1));
  if (sub === "app") return { kind: "app" };
  if (sub === "admin") return { kind: "admin" };
  return /^[a-z0-9](?:[a-z0-9-]{1,30}[a-z0-9])$/.test(sub) && !RESERVED.has(sub) ? { kind: "tenant", slug: sub } : { kind: "other" };
}

/** https://{sub}.{base} (keeps the current port, for the local mock). */
export function originOf(sub: string) {
  return `${location.protocol}//${sub}.${config().base}${location.port ? `:${location.port}` : ""}`;
}

export const isSlug = (s: string) => /^[a-z0-9](?:[a-z0-9-]{1,30}[a-z0-9])$/.test(s) && !RESERVED.has(s);
